import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setSelectedCard } from "../../state/actions/Cards";
import VariantInfo from "../variant/VariantInfo";

import {
  getInfo,
  getQueryType,
  getEmailVerificationState,
  getLoading,
  getError,
  getErrorId,
} from "../../state/selectors/general.selectors";
import {
  getSelectedCard,
  getVariantQueryMode,
  getCardsIsOnSide,
} from "../../state/selectors/CardsUI.selectors";

const SubHeader = ({ queryType, emailVerificationNeeded }) => {
  const isSingleRead = queryType === "single-read";
  const shouldShowVariantInfo = !(isSingleRead || emailVerificationNeeded);
  return (
    <div className="tw-overflow-auto tw-pointer-events-auto">
      {shouldShowVariantInfo ? <VariantInfo /> : null}
    </div>
  );
};

SubHeader.propTypes = {
  info: PropTypes.shape({}),
  queryType: PropTypes.string,
  emailVerificationNeeded: PropTypes.bool,
  error: PropTypes.shape({}),
};

SubHeader.defaultProps = {
  info: {},
  queryType: "",
  emailVerificationNeeded: false,
  error: null,
};

const mapStateToProps = (state) => ({
  selectedCard: getSelectedCard(state),
  isCardsOnSide: getCardsIsOnSide(state),
  variantQueryMode: getVariantQueryMode(state),
  isLoading: getLoading(state),
  info: getInfo(state),
  queryType: getQueryType(state),
  emailVerificationNeeded: getEmailVerificationState(state),
  error: getError(state),
  errorId: getErrorId(state),
});

const mapDispatchToProps = (dispatch) => ({
  selectCard: (params) => dispatch(setSelectedCard(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubHeader);
